import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { useUploadFlowContext } from "panels/content/side-panel/upload-flow/useUploadFlowContext"
import { AddMoreDropBox } from "panels/content/dropbox/AddMoreDropBox"
import { mapExtensionsToMimeType } from "features/job-management/uploader/constants"
import { AutoProcessController } from "panels/content/side-panel/upload-flow/preview-files/AutoProcessController"
import { UploadDropBox } from "./UploadDropBox"

const dedupeKeyFromId = (id: string) => {
    const parts = id.split(".")
    return `${parts.slice(0, -3).join(".")}.${parts.at(-3)}`
}

export const FlightUploadDropbox = ({
    isAddMoreFiles,
    className = "mb-2",
}: {
    isAddMoreFiles?: boolean
    className?: string
}) => {
    const {
        supportedFileUploadExtensions,
        portfolioId,
        fireId,
        flightId,
        stageFiles,
        fileFilter,
        maxUploads,
        dropboxTitle,
        selectFlightById,
        uploads,
    } = useUploadFlowContext()
    const dispatch = useAppDispatch()
    const flight = useAppSelector<{ images?: { id: string }[] } | undefined>(
        selectFlightById(flightId || "")
    )
    if (!portfolioId || !fireId || !flightId)
        throw new Error("Data tab is open without all activated data")
    const addFiles = async (files: File[]) => {
        if (fileFilter) {
            try {
                files = await fileFilter(files)
            } catch (err) {
                console.error(err)
            }
        }

        const uploaded = new Set(
            [...(flight?.images ?? []), ...uploads].map(({ id }) => dedupeKeyFromId(id))
        )
        files = files.filter(
            (file) => !uploaded.has(`${file.name.split(".").slice(0, -1).join(".")}.${file.size}`)
        )
        if (files.length === 0) return

        dispatch(
            stageFiles(portfolioId, fireId, flightId, files, () => {
                AutoProcessController.emit(`flightId:${flightId}:uploaded-all`)
            })
        )
    }

    if (isAddMoreFiles)
        return (
            <AddMoreDropBox
                allowedFileExtensions={supportedFileUploadExtensions}
                isProcessing={false}
                onNewItems={addFiles}
                canAcceptMultiple={maxUploads ? maxUploads > 1 : true}
                supportedMimeTypes={supportedFileUploadExtensions.map(
                    (extension) => mapExtensionsToMimeType[extension]
                )}
                className={className}
            />
        )

    return (
        <UploadDropBox
            title={dropboxTitle || "Upload Images"}
            allowedFileTypes={supportedFileUploadExtensions}
            canAcceptMultiple={maxUploads ? maxUploads > 1 : true}
            onNewItems={addFiles}
            isProcessing={false}
            supportedMimeTypes={supportedFileUploadExtensions.map(
                (extension) => mapExtensionsToMimeType[extension]
            )}
            allowFolders={maxUploads ? maxUploads > 2 : true}
        />
    )
}
